// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbr_a"};